import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITextMateTokenizationService = ( createDecorator('textMateTokenizationFeature'));
export { ITextMateTokenizationService };
